import React from 'react'
import { Link } from 'react-router-dom'
import BoozeBgrn from "../assets/images/BoozeBgrn.jpg";
import GeenWinesCart from "../assets/images/GeenWinesCart.jpg";

const Checkout = () => {
  return (
    <>
<section>
  <h1 className="sr-only">Checkout</h1>
  <div className="relative mx-auto max-w-screen-2xl">
    <div className="grid grid-cols-1 md:grid-cols-3 mx-6">
    <div className="py-12 bg-white col-span-2 md:py-24">

        <div className="px-4 ml-16">
    <h1 className='font-bold text-3xl text-purple-800 mb-16 text-center sm:text-left'>Billing Information</h1>
          <form className="grid grid-cols-8 gap-4">
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="first_name">
                First Name
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="text" id="first_name" />
            </div>
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="last_name">
                Last Name
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="text" id="last_name" />
            </div>
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="email">
                Email
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="email" id="email" />
            </div>
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="phone">
                Phone
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="tel" id="phone" />
            </div>
            <fieldset className="col-span-8">
              <legend className="block mb-2 text-sm text-gray-600">
                Location
              </legend>
              <div className="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label className="sr-only" htmlFor="country">Country</label>
                  <select className="border border-gray-600 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5" id="country" name="country" autoComplete="country-name">
                    <option>Kenya</option>
                  </select>
                </div>
                <div>
                  <label className="sr-only" htmlFor="postal-code">
                    Postal Address
                  </label>
                  <input className="border border-gray-600 relative rounded-b-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400" type="text" name="postal-code" id="postal-code" autoComplete="postal-code" placeholder="Postal Address" />
                </div>
              </div>
            </fieldset>
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="phone">
                City/Town
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="tel" id="phone" />
            </div>
            <div className="col-span-4">
              <label className="block mb-2 text-sm text-gray-600" htmlFor="phone">
                County/State
              </label>
              <input className="rounded-lg shadow-sm border border-gray-600 w-full text-sm p-2.5" type="tel" id="phone" />
            </div>
            <fieldset className="col-span-8">
              <legend className="block mb-2 text-sm text-gray-600">
                Card Details
              </legend>
              <div className="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label className="sr-only" htmlFor="card-number">Card Number</label>
                  <input className="border border-gray-600 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400" type="text" name="card-number" id="card-number" placeholder="Card number" />
                </div>
                <div className="flex -space-x-px">
                  <div className="flex-1">
                    <label className="sr-only" htmlFor="card-expiration-date">
                      Expiration Date
                    </label>
                    <input className="border border-gray-600 relative rounded-bl-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400" type="text" name="card-expiration-date" id="card-expiration-date" placeholder="MM / YY" />
                  </div>
                  <div className="flex-1">
                    <label className="sr-only" htmlFor="card-cvc">CVC</label>
                    <input className="border border-gray-600 relative rounded-br-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400" type="text" name="card-cvc" id="card-cvc" placeholder="CVC" />
                  </div>
                </div>
              </div>
            </fieldset>
      
            
              <button className="rounded-lg bg-black text-sm py-2.5  text-white block" type="submit">
                Pay Now
              </button>
          
          </form>
        </div>
      </div>
      <div className="py-12  md:py-32">
        <div className="max-w-lg px-4 mx-auto lg:px-4">
          <div className="flex items-center">
            <span className="w-10 h-10 bg-blue-800 rounded-full" />
            <h2 className="ml-4 font-medium">Booze and Gin</h2>
          </div>
          <div className="mt-8">
            <p className="text-2xl font-medium tracking-tight">$99.99</p>
            <p className="mt-1 text-sm text-gray-500">For the purchase of</p>
          </div>
          <div className="mt-12">
            <div className="flow-root">
              <ul className="-my-4 divide-y divide-gray-200">
                <li className="flex items-center justify-between py-4">
                  <div className="flex items-start">
                    <img className="flex-shrink-0 object-cover w-16 h-16 rounded-lg" src={BoozeBgrn} alt="geenwines-cart" />
                    <div className="ml-4">
                      <p className="text-sm">Wonder Wine</p>
                      <dl className="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt className="inline">Wine</dt>
                        </div>
                        <div>
                          <dt className="inline">500 ML</dt>
                        </div>
                      </dl>
                    </div>
                  </div>
                  <div>
                    <p className="text-lg text-black font-bold">
                      $49.99
                      <small className="ml-2">x1</small>
                    </p>
                  </div>
                </li>
                <li className="flex items-center justify-between py-4">
                  <div className="flex items-start">
                    <img className="flex-shrink-0 object-cover w-16 h-16 rounded-lg" src={GeenWinesCart} alt="geen-wines-cart" />
                    <div className="ml-4">
                      <p className="text-sm">Valous Vodka</p>
                      <dl className="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt className="inline">Vodka</dt>
                        </div>
                        <div>
                          <dt className="inline">Shot</dt>
                        </div>
                      </dl>
                    </div>
                  </div>
                  <div>
                    <p className="text-lg text-black font-bold">
                      $25
                      <small className="ml-2">x2</small>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
<div className="flex flex-col my-6">

    <div className="form-check my-6">
   <div className='card py-4 bg-gray-200 rounded'>
      <input className="ml-4 form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 my-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="radio" name="flexRadioDefault" id="flexRadioDefault10" />
Lipa Na Mpesa
   </div>
    </div>
    <div className="form-check my-6">
   <div className='card py-4 bg-gray-200 rounded'>
      <input className="ml-4 form-check-input rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 my-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="radio" name="flexRadioDefault" id="flexRadioDefault10" />
      Pay on Delivery
   </div>
    </div>
 
</div>

              <button className="rounded-lg bg-green-800 text-sm p-2.5 text-white justify-right block" type="submit">
                Order
              </button>
            
          </div>
          <div>
          </div>
        </div>
      </div>
    
    </div>
  </div>
</section>

    </>
  )
}

export default Checkout